import React, { createContext, useContext, ReactNode } from 'react';
import ApiClient from '../../lib/api-client';
import { IClientFileDTO } from '@common-frontend-submodule/interfaces/client-file/iclient-file.interface';
import { IClientFileCreationDTO } from '@common-frontend-submodule/interfaces/client-file/iclient-file-creation.interface';
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface';
import { ClientFileRoutes } from '@common-frontend-submodule/enums/routes/client-file-routes.enum';

const apiClient = ApiClient.getInstance()

interface ClientFileContextProps {
  getById: (assignmentFileId: string) => Promise<IApiResponseGenericDTO<IClientFileDTO>>;
  getAll: (assignmentId: string) => Promise<IApiResponseGenericDTO<IClientFileDTO[]>>;
  delete: (assignmentFileId: string) => Promise<IApiResponseGenericDTO<boolean>>;
  create: (file: File, model: IClientFileCreationDTO) => Promise<IApiResponseGenericDTO<IClientFileDTO>>;
}

const ClientFileContext = createContext<ClientFileContextProps | undefined>(undefined);

export const ClientFileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const getById = async (assignmentFileId: string): Promise<IApiResponseGenericDTO<IClientFileDTO>> => {
    return await apiClient.getRequest<IClientFileDTO>(`${ClientFileRoutes.BasePrefix}/${assignmentFileId}`);
  };

  const getAll = async (assignmentId: string): Promise<IApiResponseGenericDTO<IClientFileDTO[]>> => {
    return await apiClient.getRequest<IClientFileDTO[]>(`${ClientFileRoutes.BasePrefix}/all/${assignmentId}`);
  };

  const create = async (file: File, model: IClientFileCreationDTO): Promise<IApiResponseGenericDTO<IClientFileDTO>> => {
    const formData = new FormData();

    formData.append('file', file);

    Object.entries(model).forEach(([key, value]) => {
      formData.append(key, value as string); // Преобразуем значение в строку
    });
  
    return await apiClient.postFormDataRequest<FormData, IClientFileDTO>(
        ClientFileRoutes.BasePrefix,
      formData,
    );
  };

  const deleteClientFile = async (assignmentFileId: string): Promise<IApiResponseGenericDTO<boolean>> => {
    return await apiClient.deleteRequest<null, boolean>(`${ClientFileRoutes.BasePrefix}/${assignmentFileId}`);
  };

  return (
    <ClientFileContext.Provider value={{ getById, getAll, create, delete: deleteClientFile }}>
      {children}
    </ClientFileContext.Provider>
  );
};

export const useClientFileStore = () => {
  const context = useContext(ClientFileContext);
  if (!context) {
    throw new Error('useClientFileStore must be used within a ClientFileProvider');
  }
  return context;
};
